<script lang="ts">
  import { allWorkoutPlayers, workoutPlayerTypeToName } from "@/Common/constants";
  import Button from "@/lib/components/ui/button/button.svelte";
  import { connectedWorkoutPlayers } from "@/Singletons/WorkoutPlayersWritable";
  import type { WorkoutPlayerType } from "@/Util/api";

  function redirectIfNeeded(type: WorkoutPlayerType): boolean {
    if (type == 'garmin_connect') {
      if (typeof window !== 'undefined') {
        window.open('/garmin-health/sync', '_blank', 'noopener,noreferrer');
      }
    } else if (type == 'zwift') {
      if (typeof window !== 'undefined') {
        window.open('/sync/zwift', '_blank', 'noopener,noreferrer');
      }
    } else if (type =='wahoo') {
      if (typeof window !== 'undefined') {
        window.open('/sync/wahoo', '_blank', 'noopener,noreferrer');
      }
    } else {
      return false;
    }
    return true;
  }

  function handleAddWorkoutPlayer(type: WorkoutPlayerType) {
    if (!redirectIfNeeded(type)) connectedWorkoutPlayers.addWorkoutPlayer(type);
  }

  function handleRemoveWorkoutPlayer(type: WorkoutPlayerType) {
    if (!redirectIfNeeded(type)) connectedWorkoutPlayers.removeWorkoutPlayer(type);
  }
  
</script>

<div class='flex flex-col gap-2'>
  {#each allWorkoutPlayers as wp}
    {#if wp != 'xert_ebc'}
      <div class='flex flex-row items-center gap-2 justify-between'>
        <span>{workoutPlayerTypeToName[wp]}</span>
        {#if $connectedWorkoutPlayers.players.find(p => p.type === wp)}
          <Button size='sm' on:click={() => handleRemoveWorkoutPlayer(wp)}>
            Remove <i class='fa-solid fa-xmark ml-1' />
          </Button>
        {:else}
          <Button size='sm' on:click={() => handleAddWorkoutPlayer(wp)}>
            Add <i class='fa-solid fa-plus ml-1' />
          </Button>
        {/if}
      </div>
    {/if}
  {/each}
</div>
